import React, { useState } from 'react';
import { View, Text, TextInput, Switch } from 'react-native';
import styles from '@stylesheet';
import updateStoreHandler from '../utils/updateStoreHandler';
import * as Animatable from 'react-native-animatable';
import ComponentRenderer from './ComponentRenderer';
import defaultValComponents, { ValidationComponentType } from '../utils/defaultValComponents';

const NumberValidation = ({ item, index }) => {


  // Define an array of configuration objects for each component
  const validationComponents: ValidationComponentType[] = [
    ...defaultValComponents,
    { key: 'minValue', label: 'Min Value', type: 'textInput', inputMode: 'numeric' },
    { key: 'maxValue', label: 'Max Value', type: 'textInput', inputMode: 'numeric' },
    { key: 'integerOnly', label: 'Integer Only?', type: 'switch' },
  ];

   return (
    <View style={[styles.validationView, { flexWrap: 'wrap' }]}>
      {validationComponents.map((component) => (
        <View key={component.key} style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', position: 'relative', flexWrap: 'wrap' }}>
          {
            component.type === 'switch' &&
            <Text style={{ flex: 1 }}>{component.label}</Text>
          }
          <ComponentRenderer item={item} component={component} index={index}/>
        </View>
      ))}
    </View>
  );
};

export default NumberValidation;
